import { alpha } from '@mui/material/styles';
import {
  RADIUS,
  UNIVERSE_FONT,
  accentOf,
  accentTint,
  fillOf,
  hairlineOf
} from 'src/theme/universe/brand';

// ---------------------------------------------------------------------------
// THE DATE PICKERS' LAYERS on a vendor page (DESIGN.md §18 Date, §25).
//
// The pickers render their calendar in a popper, or in a dialog on a touch
// screen, outside the page's subtree — and they paint the chosen day, today's
// ring and the dialog's OK in `palette.primary`, which is still the template's
// green (§4: phase 0 has not landed on the global palette). So, while a vendor
// page is mounted, its pickers' layers wear the accent and the Universe
// paper; an intranet page opened next is untouched. Both generations of the
// pickers the portal ships are named — @mui/lab's (x-date-pickers 5) and
// x-date-pickers 6, which the profile and the offer forms import directly.
// ---------------------------------------------------------------------------

export const pickerLayerStyles = (theme) => {
  const light = theme.palette.mode === 'light';
  const accent = accentOf(theme);
  const fill = fillOf(theme);
  return {
    '.MuiPickersPopper-paper, .MuiPickersPopper-root .MuiPaper-root': {
      borderRadius: `${RADIUS.overlay}px !important`,
      border: `1px solid ${hairlineOf(theme)}`,
      boxShadow: light
        ? '0 16px 40px -8px rgba(1,38,109,.20) !important'
        : '0 20px 48px -10px rgba(0,0,0,.6), inset 0 1px 0 rgba(255,255,255,.08) !important',
      backgroundImage: 'none'
    },
    '.MuiPickersDay-root, .MuiPickersYear-yearButton, .MuiPickersMonth-monthButton, .PrivatePickersYear-yearButton, .PrivatePickersMonth-root':
      { fontFamily: `${UNIVERSE_FONT} !important` },
    '.MuiPickersDay-root.Mui-selected, .MuiPickersDay-root.Mui-selected:hover, .MuiPickersDay-root.Mui-selected:focus, .PrivatePickersYear-yearButton.Mui-selected, .MuiPickersYear-yearButton.Mui-selected, .PrivatePickersMonth-root.Mui-selected, .MuiPickersMonth-monthButton.Mui-selected':
      {
        backgroundColor: `${fill} !important`,
        color: '#FFFFFF !important'
      },
    '.MuiPickersDay-root.MuiPickersDay-today:not(.Mui-selected)': {
      border: `1px solid ${accent} !important`,
      color: accent
    },
    '.MuiPickersDay-root:hover:not(.Mui-selected)': {
      backgroundColor: `${accentTint(theme, 'hover')} !important`
    },
    // the touch dialog: its head band and its two verbs
    '.MuiPickersToolbar-root .MuiTypography-root.Mui-selected, .MuiPickersToolbar-penIconButton':
      { color: `${accent} !important` },
    '.MuiDialog-root .MuiDialogActions-root .MuiButton-root, .MuiPickersLayout-actionBar .MuiButton-root':
      {
        fontFamily: `${UNIVERSE_FONT} !important`,
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 999,
        color: `${accent} !important`,
        '&:hover': { backgroundColor: `${alpha(accent, light ? 0.06 : 0.1)} !important` }
      },
    '.MuiClockPointer-root, .MuiClock-pin, .MuiClockPointer-thumb': {
      backgroundColor: `${fill} !important`,
      borderColor: `${fill} !important`
    },
    '.MuiClockNumber-root.Mui-selected, .MuiMultiSectionDigitalClockSection-item.Mui-selected': {
      backgroundColor: `${fill} !important`,
      color: '#FFFFFF !important'
    }
  };
};
